import dayjs from 'dayjs'

const DATE_MATCHER = /(\d{8})/

export function copyName(articleTitle: string) {
  const today = dayjs(new Date()).format('YYYYMMDD')
  return replaceOrAddDate(articleTitle, today)
}

function replaceOrAddDate(title: string, todayAsString: string) {
  return title.match(DATE_MATCHER) === null
    ? `${title} - ${todayAsString}`
    : title.replace(new RegExp(DATE_MATCHER), `${todayAsString}`)
}
